// Price Text Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import currency from '../../../lib/currency.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class PriceText extends Component {
  static get propTypes () {
    return {
      value: PropTypes.number,
      showProMemoria: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      value: 0,
      showProMemoria: false
    }
  }

  shouldComponentUpdate (nextProps, _nextState) {
    const { value } = this.props
    if (!_.isEqual(value, nextProps.value)) {
      return true
    }
    return false
  }

  render () {
    const { value, showProMemoria } = this.props
    const extraClass = currency.getCurrency() === 'USD' ? ' symbol-usd' : ''

    if (value === 0 && showProMemoria) {
      return <IntlMessage ident='project.viewBudget.proMemoria' />
    }

    return [
      <span className={`currency-symbol${extraClass}`} key='currency-symbol'>
        {currency.symbol()}&nbsp;
      </span>,
      <span className='currency-value' key='currency-value'>
        {currency.format(value)}
      </span>
    ]
  }
}

export default PriceText
